import ButtonCellSchevronComponent from "./ButtonCellSchevron";
import {
    Label,
    Subtitle,
    Value,
    BottomAddon,
} from "./components/Base/ButtonCellSchevronBase";
import LeftIcon from "./components/LeftIcon/ButtonCellSchevronLeftIcon";

export interface IButtonCellSchevronExtensions {
    Label: typeof Label;
    Subtitle: typeof Subtitle;
    Value: typeof Value;
    LeftIcon: typeof LeftIcon;
    BottomAddon: typeof BottomAddon;
}

export const ButtonCellSchevron: typeof ButtonCellSchevronComponent &
    IButtonCellSchevronExtensions = Object.assign(ButtonCellSchevronComponent, {
    Label,
    Subtitle,
    Value,
    LeftIcon,
    BottomAddon,
});
